module.exports = {
      id: "nutstore-2-icon-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "images/js_src_vue/page_eagle_landing/sprite.b4f41d19.svg#nutstore-2-icon-usage",
      toString: function () {
        return this.url;
      }
    }